// $(document).ready(function () {
//     $('#scripts').on('click', '.js_load_detail', function () {
//         const id = $(this).data('id')
//         $.get(
//             '/script',
//             {
//                 id: $(this).data('id')
//             },
//             function (result) {
//                 if ($('#detail_script .card-body').length === 0) {
//                     $('#detail_script').append('<div class="card-body"></div>')
//                 }
//                 $('#detail_script .card-body').html(result)
//             }
//         )
//     })
//
//     $('#scripts').on('click', '#add_group, .js_group_edit', function () {
//         $.get(
//             '/script/group',
//             {
//                 id: $(this).data('id')
//             },
//             function (result) {
//                 $('#modal_edit').modal('show')
//                 if ($('#modal_edit .modal-body').length === 0) {
//                     $('#modal_edit').append('<div class="modal-body"></div>')
//                 }
//                 $('#modal_edit .modal-body').html(result)
//             }
//         )
//     })
//
//     $('#scripts').on('click', '#add_script, #edit_script', function () {
//         $.get(
//             '/script/edit',
//             {
//                 id: $(this).data('id')
//             },
//             function (result) {
//                 $('#modal_edit').modal('show')
//                 if ($('#modal_edit .modal-body').length === 0) {
//                     $('#modal_edit').append('<div class="modal-body"></div>')
//                 }
//                 $('#modal_edit .modal-body').html(result)
//             }
//         )
//     })
//     $('#scripts').on('click', '#save_group', function () {
//         $.post(
//             '/script/group/save',
//             {
//                 id: $(this).data('id'),
//                 name: $('#name').val(),
//                 sort: $('#sort').val()
//             },
//             function (result) {
//                 $('#groups_script').html(result)
//                 $('#modal_edit').modal('hide')
//             }
//         )
//     })
//     $('#scripts').on('click', '#save_script', function () {
//         $.post(
//             '/script/',
//             {
//                 id: $(this).data('id'),
//                 name: $('#name').val(),
//                 text: $('#text').val(),
//                 group_id: $('#group').val(),
//                 sort: $('#sort').val()
//             },
//             function (result) {
//                 $('#groups_script').html(result)
//                 $('#modal_edit').modal('hide')
//             }
//         )
//     })
// })

window.scripts = function (isDirector = false) {

    let groupLists = []
    let scriptLists = []

    const init = function () {
        load()
        event()
    }


    const event = function () {
        $('#scripts').on('change, keyup', '#search', function () {
            const val = $(this).val()
            $('#groups_script').html(renderGroup())
        })

        $('#scripts').on('click', '.js_load_detail', function () {
            const id = $(this).data('id');
            $('.js_load_detail').removeClass('active');
            $(this).addClass('active');
            if ($('#detail_script .card-body').length === 0) {
                $('#detail_script').append('<div class="card-body"></div>')
            }
            $('#detail_script .card-body').html(renderDetail(id))

        })

        //изменение
        $('#scripts').on('click', '#add_group, .js_group_edit', function () {
            $.get(
                '/script/group',
                {
                    id: $(this).data('id')
                },
                function (result) {
                    $('#modal_edit').modal('show')
                    if ($('#modal_edit .modal-body').length === 0) {
                        $('#modal_edit').append('<div class="modal-body"></div>')
                    }
                    $('#modal_edit .modal-body').html(result)
                }
            )
        })
        $('#scripts').on('click', '#add_script, #edit_script', function () {
            $.get(
                '/script/edit',
                {
                    id: $(this).data('id')
                },
                function (result) {
                    $('#modal_edit').modal('show')
                    $('#modal_content').html(result)

                }
            )
        })
        //сохранение
        $('#scripts').on('click', '#save_group', function () {
            $.post(
                '/script/group/save',
                {
                    id: $(this).data('id'),
                    name: $('#name').val(),
                    sort: $('#sort').val()
                },
                function (result) {
                    load()
                    $('#modal_edit').modal('hide')
                }
            )
        })
        //удалить
        $('#scripts').on('click', '.js_group_remove', function () {
            const isConfirm = confirm('Удалить группу? Все скрипты в ней будут удалены')
            if (isConfirm) {
                $.post(
                    '/script/group/delete',
                    {
                        id: $(this).data('id')
                    },
                    function (result) {
                        load()
                    }
                ).fail(function (error) {
                    alert(error.responseJSON.error)
                })
            }
        })
        $('#scripts').on('submit', '#save_script', function (e) {
            e.preventDefault();
            $.post(
                '/script/',
                {
                    id: $(this).data('id'),
                    name: $('#name').val(),
                    text: $('#text').val(),
                    group_id: $('#group').val(),
                    sort: $('#sort').val()
                },
                function (result) {
                    load(function () {
                        $('#detail_script .card-body').html(renderDetail(result.id))
                    })
                    $('#modal_edit').modal('hide')
                }
            ).fail(function(xhr, status, error) {
                $('#error_script').text(xhr.responseJSON.message)
            })
        })
        $('#scripts').on('click', '#remove_script', function (e) {
            e.preventDefault();
            $.post(
                '/script/delete',
                {
                    id: $(this).data('id')
                },
                function (result) {
                    load()
                    $('#modal_edit').modal('hide')
                }
            ).fail(function (error) {
                alert(error.responseJSON.error)
            })
        })
        $('#scripts').on('click', '[data-dismiss="modal"]', function () {
            $('#modal_edit').modal('hide')
        })
    }

    const load = function (callback = null) {
        $.get(
            '/script/load',
            function (result) {
                groupLists = result.groups
                scriptLists = result.scripts

                $('#groups_script').html(renderGroup())
                if(!!callback) {
                    callback()
                }

            }
        )
    }

    const escapeHtml = function (value) {
        return String(value ?? '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    const getScript = function (id) {
        return scriptLists.find(script => {
            return Number(script.id) === Number(id)
        })
    }

    const renderDirectionState = function (script) {
        if (!script || !script.direction_state || !Array.isArray(script.direction_state.items)) {
            return ''
        }

        return `<span class="dentalis-scripts__state-tags">`
            + script.direction_state.items.map(item => {
                const typeClass = item.type === 'warning'
                    ? 'dentalis-scripts__state-tag--warning'
                    : `badge-${item.type}`

                return `<span class="badge ${typeClass} dentalis-scripts__state-tag">${escapeHtml(item.label)}</span>`
            }).join('')
            + `</span>`
    }

    // const search = function (val) {
    //     groups.filter(group => {
    //         const scripts = group.scripts.filter(script => {
    //             if (script.name.toLowerCase().indexOf(val.toLowerCase()) !== -1) {
    //                 return true
    //             }
    //         })
    //
    //         return scripts.length > 0
    //     })
    // }

    const renderGroup = function () {
        const search = $('#search').val()
        return groupLists.filter(group => {

            if (!search) {
                return true
            }

            const scripts = group.scripts.filter(script => {
                if (script.name.toLowerCase().indexOf(search.toLowerCase()) !== -1) {
                    return true
                }
            })

            return scripts.length > 0
        }).map(group => {
            return `
            <div class="row">
                <div class="col">
                    <div class="card dentalis-scripts__groups">
                        <div class="card-header">
                            <h3 class="card-title">${escapeHtml(group.name)} — ${escapeHtml(group.branch ? group.branch.name : 'общие')}</h3>
                            <div class="card-tools">`
                                + (isDirector ? `<button type="button" title="Редактировать группу" class="btn btn-tool js_group_edit" data-id="${group.id}">
                                    <i class="fas fa-lg fa-edit"></i>
                                </button>` : '')
                                +`<button type="button" class="btn btn-tool" title="Свернуть" data-card-widget="collapse">
                                    <i class="fas fa-lg fa-minus"></i>
                                </button>`
                                + (isDirector ? `<button type="button" class="btn btn-tool js_group_remove" title="Удалить группу" data-id="${group.id}">
                                    <i class="fas fa-lg fa-times"></i>
                                </button>` : '')
                            + `</div>
                        </div>
                        <div class="card-body">
                        ${group.scripts.filter(script => {
                            if (script.name.toLowerCase().indexOf(search.toLowerCase()) !== -1) {
                                return true
                            }
                        }).map(script => {
                            const scriptData = getScript(script.id) || script

                            return `
                                <div class="row dentalis-scripts__script-item">
                                    <div class="col dentalis-scripts__script-name js_load_detail" data-id="${script.id}">
                                        <span>${escapeHtml(script.name)}</span>
                                        ${renderDirectionState(scriptData)}
                                    </div>
                                </div>
                            `
                        }).join('')}
                        </div>
                    </div>
                </div>
            </div>
            `
        })
    }

    const renderDetail = function (id) {
        const script = scriptLists.find(script => {
            return script.id === id
        })
        return `
        <div class="row">
            <div class="col dentalis-scripts__detail-edit">
            <div class="dentalis-scripts__detail-name">
                <span>${escapeHtml(script.name)}</span>
                ${renderDirectionState(script)}
            </div>`
            + (isDirector ?
                (script.relation_url ?
                    `<a href="${script.relation_url}" type="button" class="dentalis-btn">
                        <i class="fas fa-sm fa-edit"></i>Изменить скрипт</a>` :
                    `<button type="button" class="dentalis-btn" id="edit_script" data-id="${script.id}">
                    <i class="fas fa-sm fa-edit"></i>      Изменить скрипт </button>`) :
                '') +
            `</div>
        </div>
        <div class="row">
            <div class="col">
                ${script.text}
            </div>
        </div>
        `
    }

    init()
}
